'use client';

import { __styles, mergeClasses } from '@griffel/react';
import { useDividerStyles_unstable } from '@fluentui/react-divider';
export const navDividerClassNames = {
  root: 'fui-NavDivider',
  wrapper: 'fui-NavDivider__wrapper'
};
const useStyles = /*#__PURE__*/__styles({
  root: {
    Bh6795r: "f1jhi6b8",
    B6of3ja: "fvjh0tl",
    jrapky: "fd1gkq"
  }
}, {
  d: [".f1jhi6b8{flex-grow:0;}", ".fvjh0tl{margin-top:4px;}", ".fd1gkq{margin-bottom:4px;}"]
});
/**
 * Apply styling to the NavDivider slots based on the state
 */
export const useNavDividerStyles_unstable = state => {
  const styles = useStyles();
  // eslint-disable-next-line react-hooks/immutability
  state.root.className = mergeClasses(navDividerClassNames.root, styles.root, state.root.className);
  // eslint-disable-next-line react-hooks/immutability
  state.wrapper.className = mergeClasses(navDividerClassNames.wrapper, state.wrapper.className);
  useDividerStyles_unstable(state);
  return state;
};